exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-expert-profile-template-tsx": () => import("./../../../src/templates/expert-profile-template.tsx" /* webpackChunkName: "component---src-templates-expert-profile-template-tsx" */)
}

